// extracted by mini-css-extract-plugin
module.exports = {"menu":"styles_menu__1z3pf","button":"styles_button__2BgIu","cartItemsAmount":"styles_cartItemsAmount__3QD5J"};